import React from "react";
import Grid from "@mui/material/Grid2";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  rectSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const SortableImage = ({ image, index, removeImage }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: image.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    height: "200px",
    border: "1px solid #eaeaea",
    borderRadius: 4,
    marginRight: 8,
    marginTop: 16,
    marginBottom: 8,
    cursor: "move",
    position: "relative",
    maxWidth: "100%",
  };

  return (
    <Grid ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <div
        style={{
          position: "absolute",
          right: 4,
          top: 4,
          cursor: "pointer",
          zIndex: 1,
        }}
        onPointerDown={(e) => e.stopPropagation()}
        onClick={() => removeImage(image, index)}
      >
        <DeleteIcon />
      </div>
      <img
        draggable={false}
        alt={`img - ${image.id}`}
        src={image.src}
        style={{ width: "100%", height: "100%" }}
      />
    </Grid>
  );
};

const ImageList = ({ images, moveImage, removeImage }) => {
  const sensors = useSensors(useSensor(PointerSensor));

  function handleDragEnd(event) {
    const { active, over } = event;
    if (active.id !== over?.id) {
      const oldIndex = images.findIndex((img) => img.id === active.id);
      const newIndex = images.findIndex((img) => img.id === over.id);
      moveImage(arrayMove(images, oldIndex, newIndex));
    }
  }

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext
        items={images.map((img) => img.id)}
        strategy={rectSortingStrategy}
      >
        <Grid container>
          {images.map((image, index) => (
            <SortableImage
              key={image.id}
              image={image}
              index={index}
              removeImage={removeImage}
            />
          ))}
        </Grid>
      </SortableContext>
    </DndContext>
  );
};

export default ImageList;
